export default function getClassNames(...obj) {
  return obj.filter((c) => c).join(" ");
}
